import controller from './report-grid-square-controller';
import template from './report-grid-square.html'

const ReportGridSquareComponent = {
    bindings: {
        colorClass: '<',
        optionalClass: '<',
        icon: '<',
        isComplete: '<',
        isInProgress: '<'
    },
    controller,
    template
};

export default ReportGridSquareComponent;



// WEBPACK FOOTER //
// ./app/common/report-grid-square/report-grid-square-component.js